//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

import universalImageActionsTributaryTypeaheadTemplate from '@legacy-components/common/universal-image-actions/universal-image-actions-tributary-typeahead.html';
import universalImageActionsTributaryTypeaheadSuggestionTemplate from '@partials/universal-image-actions-tributary-typeahead-suggestion.html';
import acornBrokenImage from '@images/acorn-broken.svg';
import acornSearchImage from '@images/acorn-search.svg';

/* global angular: false, _: false */

(function() {
  const uia = angular.module('uia');

  uia.directive('universalImageActionsTributaryTypeahead', [
    function() {
      return {
        restrict: 'E',
        scope: {
          selectItemCallback: '&',
          currentCustomUrl: '=',
        },
        require: '^universalImageActionsModal',
        template: universalImageActionsTributaryTypeaheadTemplate,
        controller: ['$scope',
          function($scope) {
            $scope.model = {};

            const isValidUrl = function(url) {
              return /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)/i.test(url);
            };

            $scope.model.currentIsValid = false;

            $scope.model.typeaheadBlurred = function($event) {
                            // The typeahead clears the input field on blur if there was no interaction (even if it's pre-populated with a custom URL).
                            // This prevents the field from clearing.
              $event.stopImmediatePropagation();
            };

            $scope.model.productSearchTypeahead = {
              currentQuery() {
                return $scope.model.searchText;
              },
              events: {
                enterKeyed($event, product) {
                  $scope.model.productSearchTypeahead.context.onSelect($event, product);
                },
              },
              context: {
                onSelect($event, product) {
                  if (isValidUrl($scope.model.searchText)) {
                    $scope.model.currentIsValid = true;
                    angular.element('.twitter-typeahead').find('input.tt-input').addClass('valid');
                    angular.element('.twitter-typeahead').find('input.tt-input').removeClass('invalid');
                  } else {
                    $scope.model.currentIsValid = false;
                    angular.element('.twitter-typeahead').find('input.tt-input').addClass('invalid');
                    angular.element('.twitter-typeahead').find('input.tt-input').removeClass('valid');
                  }

                  let resetPassthrough = false;

                  if (!isValidUrl($scope.model.productSearchTypeahead.currentQuery())) {
                    resetPassthrough = true;
                  }

                  $scope.selectItemCallback({
                    product,
                    queryUrl: $scope.model.productSearchTypeahead.currentQuery(),
                    resetPassthrough,
                  });
                },
                acornBrokenImage: acornBrokenImage,
                emptyMessageTitle: 'Nuttin\' to see here.',
                emptyMessage: 'Please enter a valid URL.',
              },
              templates: {
                suggestion: { html: universalImageActionsTributaryTypeaheadSuggestionTemplate },
                empty: {
                  html: `<placeholder-block image="${acornSearchImage}"` +
                                                             'image-height="80px"' +
                                                             'title="{{ context.emptyMessageTitle }}"' +
                                                             'subtitle="{{ context.emptyMessage }}"' +
                                                             'no-border="true"' +
                                                             'box-padding="12px"' +
                                                             'box-margin="42px">' +
                                          '</placeholder-block>',
                },
              },
              searchProducts: _.debounce(() => {
                                // // As of DEV-24487, we will not crawl the URL
              }, 400),
            };
          },
        ],
        link($scope, $element) {
                    // Prepopulate the typeahead if we already have a custom URL
          $scope.$watch('currentCustomUrl', () => {
            $scope.model.searchText = $scope.currentCustomUrl;
          });

                    // Focus on the input field when shown
          $scope.$watch(() => {
            return $element.find('input.tt-input').is(':visible');
          }, () => {
            $element.find('input.tt-input').focus();
          });

                    // Check to see if we should save the URL whenever the entry changes
          $scope.$watch('model.searchText', () => {
            $scope.model.productSearchTypeahead.context.onSelect();
          });
        },
      };
    },
  ]);
})();
